<template>
  <div class="result-wrap">
    <div class="title-wrap">
      <span class="title">
        <span class="total">
          共<span style="color: #2855f1"> {{ total }} </span>条政策</span
        >
      </span>
      <!-- <a href="#/hot-news" class="more">查看更多</a> -->
    </div>
    <ul class="result">
      <li v-for="item in dataList" :key="item.zzmhPolicyVo.title" class="result-item pointer content-wrap" @click="handleGoPage(item.zzmhPolicyVo)">
        <policy-item :status="status[item.timeType - 1]" :type="item.timeType === 1 ? 'info' : item.timeType === 2 ? 'primary' : 'info'">
          <!-- <template slot="tag">
            {{ item.originLevel }}
          </template> -->
          <template slot="title">
            {{ item.zzmhPolicyVo.title }}
          </template>
          <template slot="content">
            <div class="item">发文单位：{{ item.zzmhPolicyVo.originOrg }}</div>
            <div class="item">政策类型：{{ item.zzmhPolicyVo.policyType }}</div>
            <!-- <div class="item">申报时间：{{ item.applyTm }}</div> -->
            <div class="item">
              申报时间：{{
                item.zzmhPolicyVo.title === '青年人才租房补贴'
                  ? '每月21日～月底'
                  : item.zzmhPolicyVo.applyTimeType !== 1
                  ? item.zzmhPolicyVo.applyTm
                  : '常态受理'
              }}
              {{ item.zzmhPolicyVo.applyTimeType == 3 ? '(以具体通知为准)' : '' }}
            </div>
            <div class="item">政策内容：{{ filtersText(item.zzmhPolicyVo.cont) }}</div>
          </template>
        </policy-item>
      </li>
    </ul>
    <el-pagination
      layout="prev, pager, next"
      :current-page="params.pageNo"
      :page-size="params.pageSize"
      :background="true"
      :total="total"
      @current-change="currentChangeHandle"
    />
  </div>
</template>

<script>
import bus from '@/bus.js'
import PolicyItem from '@/components/PolicyItem'
import grid from '@/mixins/grid'
// 这下面的政策跳到企服，临时需求，小海负责
const map = {
  '本土人才培养升级奖励': 'https://qf.ningbo.gov.cn/qykj/projectDetail/52625',
  '博士后出站留甬（来甬）工作补助': 'https://qf.ningbo.gov.cn/qykj/projectDetail/52618',
  '国际行业资质证书持证奖励': 'https://qf.ningbo.gov.cn/qykj/projectDetail/52626',
  '企业赴外招聘补贴': 'https://qf.ningbo.gov.cn/qykj/projectDetail/52627',
  '企业引才奖励': 'https://qf.ningbo.gov.cn/qykj/projectDetail/52616',
  '企业引进留用大学生奖励': 'https://qf.ningbo.gov.cn/qykj/projectDetail/52615',
  '企业在职人员攻读研究生学费补贴': 'https://qf.ningbo.gov.cn/qykj/projectDetail/52614',
  '宁波市人才安居补贴（高层次人才）': 'https://qf.ningbo.gov.cn/qykj/projectDetail/52043',
  '宁波市人才安居补贴（毕业一年内来甬相关人才）': 'https://qf.ningbo.gov.cn/qykj/projectDetail/52581',
  '宁波市人才购房补贴（F类人才）': 'https://qf.ningbo.gov.cn/qykj/projectDetail/52583',
  '宁波市人才认定': 'https://qf.ningbo.gov.cn/qykj/projectDetail/52042',
  '宁波市人才购房补贴（高层次人才、人才计划人才）': 'https://qf.ningbo.gov.cn/qykj/projectDetail/52582',
}
export default {
  name: 'SelectResult',
  components: { PolicyItem },
  inject: ['searchParmas'],
  // mixins: [grid],
  data() {
    return {
      status: ['非申报期内', '申报期内', '非申报期内'],
      // module: '/zzmh/api/policy/',
      // dataForm: {
      //  applicableTalentEducation:"",
      //  applicableTalentLevel:"",
      //  policyType:"",
      //  pageNo:"",
      //  pageSize:""
      // },
      // gridOptions: {},
      // defOrders: [],
      // dataMode: {},
      dataList: '',
      params: {
        applicableTalentEducation: '',
        applicableTalentLevel: '',
        policyType: '',
        pageNo: 1,
        pageSize: 10,
        applicableObject: '2',
        title: null,
      },
      total: '',
    }
  },
  watch: {
    searchParmas: {
      handler(value) {
        this.params.title = value.value
        this.getList()
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    bus.$on('accept', (policyCheck) => {
      console.log(policyCheck)
      this.params.policyType = policyCheck.join(',')
      this.getList()
    })
  },
  mounted() {
    this.getList()
  },
  methods: {
    filtersText(str) {
      str = str.replace(/<\/?.+?>/g, '')
      str = str.replace(/&nbsp;/g, '')
      return str
    },
    currentChangeHandle(val) {
      this.params.pageNo = val
      this.getList()
      window.scroll(0, 450)
    },
    getList() {
      this.$http({ method: 'post', url: '/zzmh/api/policy/page', data: this.params }).then(({ data: res, page: page }) => {
        this.dataList = res.records
        this.total = res.total
        this.params.pageNo = res.current
        this.params.pageSize = res.size
      })
    },
    handleGoPage(row) {
      if (map[row.title]) {
        window.open(map[row.title], '_blank')
        return
      }
      this.$router.push({
        path: `/policy-detail/${row.id}?type=unit`,
      })
    },
  },
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
